import React from 'react'
import { Icon, SemanticICONS } from 'semantic-ui-react'
import { StyledSectionNavigation } from './style'

interface SectionItem {
  id: string
  label: string
  icon: SemanticICONS
}

interface Props {
  sections: SectionItem[]
}

const SectionNavigation: React.FC<Props> = ({ sections }) => {

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <StyledSectionNavigation>
      <div className='nav-items'>
        {sections.map((section) => (
          <div
            key={section.id}
            className='nav-item'
            onClick={() => scrollToSection(section.id)}
          >
            <Icon name={section.icon} />
            <span>{section.label}</span>
          </div>
        ))}
      </div>
    </StyledSectionNavigation>
  )
}

export default SectionNavigation
